exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll[data-v-655f549a] {\n  overflow: auto;\n}\n.padding[data-v-655f549a] {\n  position: relative;\n  padding: 32rem;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  min-width: 100%;\n  display: inline-grid;\n  place-items: center;\n}\n.content-wrapper[data-v-655f549a] {\n  position: relative;\n}\n.zero[data-v-655f549a] {\n  position: relative;\n  width: 0px;\n  height: 0px;\n}\n", ""]);

// exports
